export default "__VITE_ASSET__B8TVbAze__"